<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>HomeWork Tracking Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <v-icon color="error">*</v-icon>
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition"
                            offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="date" v-on="on" hint="Please Select Date"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col sm="2">
                        <v-btn class="mt-6 button" color="primary" @click="getHomeWorkTrackingReport"
                            :loading="fetch_btn_load">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-data-table v-if="report_list.length > 0" :headers="headers" :items="report_list" :search="search"
                class="mytable" id="my-table-id">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-btn rounded small color="success" outlined
                            @click="fnExcelReport('my-table-id', 'Homework Tracking Report')"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                    </v-toolbar>
                </template>
            </v-data-table>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
    data: () => ({
        fetch_btn_load: false,
        overlay: false,
        search: "",
        snackbar: false,
        menu: false,
        date: null,
        snackbar_msg: "",
        color: "",
        basepath: null,
        report_list: [],
        headers: [
            {
                text: "Sr. No.",
                value: "srNo",
                align: "center",
            },
            {
                text: "Class",
                value: "standard",
                align: "center",
            },
            {
                text: "Division",
                value: "division",
                align: "center",
            },
            {
                text: "Homework Sent - Subjects",
                value: "homeworkSent",
                align: "center",
            },
            {
                text: "Homework Not Sent - Subjects",
                value: "homeworkNotSent",
                align: "center",
            },
            {
                text: "Teacher Names / ID (Not Updated DLP)",
                value: "teachers",
                align: "center",
            },
            {
                text: "Date",
                value: "date",
                align: "center",
            },
        ],
    }),
    computed: {

    },
    mounted() {
        this.basepath = localStorage.getItem("awspath");
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Class</th>
            <th>Division</th>
            <th>Homework sent -subjects</th>
            <th>Homework not sent -subjects</th>
            <th>Teacher Names / ID (Not Updated DLP)</th>
            <th>Date</th>
            </tr>`;

            this.report_list.forEach((s) => {
                tab_text += `
            <tr>
                <td>${s.srNo}</td>
                <td>${s.standard}</td>
                <td>${s.division}</td>
                <td>${s.homeworkSent}</td>
                <td>${s.homeworkNotSent}</td>
                <td>${s.teachers}</td>
                <td>${s.date}</td>
            </tr>`;
            });

            tab_text += "</table>";

            const blob = new Blob([tab_text], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getHomeWorkTrackingReport() {
            if (this.date == "" || this.date == null) {
                this.showSnackbar("#b71c1c", "Please Select Date");
                return;
            }
            this.fetch_btn_load = true;
            let data = {
                date: this.date,
            };
            axios
                .post("/Homework/getHomeWorkTrackingReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.report_list = res.data.reportList;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.fetch_btn_load = false;
                });
        },
    },
};
</script>

<style scoped>
.breadcrumb {
    padding: 10px;

    margin-left: 80px;
    margin-top: -50px;
    font-size: medium;
    font-weight: bold;
}
</style>